import { FolderOutlined, FolderOpenOutlined } from "@ant-design/icons";
import { usePalette } from "@/shared/theme";

export function FolderIcon({
  color,
  expanded,
  className,
}: {
  color?: string | null;
  expanded?: boolean;
  className?: string;
}) {
  const palette = usePalette();
  const Icon = expanded ? FolderOpenOutlined : FolderOutlined;

  return (
    <Icon className={className} style={{ color: color ?? palette.accent[6] }} />
  );
}
